// extracted by mini-css-extract-plugin
export var markdown = "_v8-0";
export var tableWrapper = "_v8-1";